import "./style.css";
import { Col, Row, Tabs } from "antd";
import { useEffect, useState } from "react";
import { useRequiredAccess } from "../../hooks/useRequiredAccess";
import { ORG_TYPES } from "../Common/Constants";
import DeviationMonitor from "./DeviationMonitor";
import TemperatureAlert from "./Temperature";

const Alerts = () => {
  const [selectedTab, setSelectedTab] = useState("temperatureAlert");
  const checkAccess = useRequiredAccess(
    [],
    [ORG_TYPES.ADMINISTRATOR, ORG_TYPES.MANUFACTURER]
  );

  useEffect(() => {
    checkAccess();
    // eslint-disable-next-line
  }, []);

  const items = [
    {
      key: "temperatureAlert",
      label: "Alerts",
      children: <TemperatureAlert selectedTab={selectedTab} />,
    },
    {
      key: "deviationMonitor",
      label: "Deviation Monitor",
      children: <DeviationMonitor selectedTab={selectedTab} />,
    },
  ];

  const onChangeTab = (key) => {
    setSelectedTab(key);
  };

  return (
    <Row>
      <Col span={24}>
        <Tabs activeKey={selectedTab} items={items} onChange={onChangeTab} />
      </Col>
    </Row>
  );
};

export default Alerts;
